import { gql } from '@generated/gql';

export const createBasketQuery = gql(`
  mutation CreateBasket($address: AddressInput!, $homeOwnerStatus: HomeOwnerStatus!, $attributionToken: String, $purpose: BasketPurpose) {
    createBasket(address: $address, homeOwnerStatus: $homeOwnerStatus, attributionToken: $attributionToken, purpose: $purpose) {
      ...BundleBasket
    }
  }
`);

export const anchoredServicesQuery = gql(`
  query AnchoredServices($address: AddressInput!) {
    anchoredServices(address: $address) {
      services {
        type
      }
    }
  }
`);
